import { render, staticRenderFns } from "./ele.vue?vue&type=template&id=6a03453e&scoped=true"
var script = {}
import style0 from "./ele.vue?vue&type=style&index=0&id=6a03453e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a03453e",
  null
  
)

export default component.exports